export default "__VITE_ASSET__BUMnUlXX__"